<template>
  <div class="vue-material-wrapper">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item">
        <md-card-header>
          <div class="md-title">Me Contacter</div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="getValidationClass('firstName')">
                <label for="firstname">Prénom</label>
                <md-input
                  name="firstname"
                  id="firstname"
                  autocomplete="given-name"
                  v-model="form.firstName"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.firstName.required"
                  >Votre prénom est obligatoire</span
                >
                <span class="md-error" v-else-if="!$v.form.firstName.minlength"
                  >Votre prénom est trop court</span
                >
              </md-field>
            </div>

            <div class="md-layout-item ">
              <md-field :class="getValidationClass('lastName')">
                <label for="lastname">Nom</label>
                <md-input
                  name="lastname"
                  id="lastname"
                  autocomplete="family-name"
                  v-model="form.lastName"
                  :disabled="sending"
                />
              </md-field>
            </div>
          </div>

          <md-field :class="getValidationClass('email')">
            <label for="email">E-mail</label>
            <md-input
              type="email"
              name="email"
              id="email"
              autocomplete="email"
              v-model="form.email"
              :disabled="sending"
            />
            <span class="md-error" v-if="!$v.form.email.required"
              >Votre e-mail est obligatoire</span
            >
            <span class="md-error" v-else-if="!$v.form.email.email"
              >votre e-mail est invalide</span
            >
          </md-field>

          <md-field>
            <label for="content">Votre message</label>
            <md-textarea
              name="content"
              id="content"
              v-model="form.content"
              :disabled="sending"
            />
          </md-field>

          <md-checkbox v-model="form.notes" :disabled="sending"
            >Je souhaite recevoir les notes du live sur la rupture
            amoureuse</md-checkbox
          >
          <input
            type="hidden"
            name="notes"
            :value="form.notes ? 'OUI' : 'NON'"
          />
        </md-card-content>


        <md-card-actions>
          <md-button
            type="submit"
            class="md-raised md-primary"
            :disabled="sending"
            >Envoyer</md-button
          >
        </md-card-actions>
        
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
      </md-card>

      <md-snackbar :md-active.sync="sent">{{ snackbarMessage }}</md-snackbar>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import emailjs from "emailjs-com";

export default {
  name: "FormValidation",
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
      email: null,
      content: null,
      notes: false,
    },
    sent: false,
    sending: false,
    snackbarMessage: null,
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.content = null;
      this.form.email = null;
      this.form.notes = null;
    },
    sendMessage(e) {
      console.log(e);
      this.sending = true;
      emailjs
        .sendForm(
          "service_pgcjo6e",
          "template_maqp08l",
          e.target,
          "user_2wEQTyOyDqbo9lH2Mjf6q"
        )
        .then(
          (result) => {
            this.sent = true;
            this.sending = false;
            this.snackbarMessage = "Votre message nous a bien été transmis";
            this.clearForm();
            console.log("envoi réussi", result);
          },
          (error) => {
            this.sent = true;
            this.sending = false;
            this.snackbarMessage =
              "Désolé, une erreur s'est produite lors de l'envoi de votre message";
            console.log("échec envoi", error);
          }
        );
    },
    validateUser(e) {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.sendMessage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-material-wrapper {
    @import "vue-material/dist/vue-material";
}
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme(
  "default",
  (
    primary: #f2ce9b,
    // The primary color of your bran
    accent: #f2ce9b,
    // The primary color of your bran
  )
);

@import "~vue-material/dist/components/MdSnackbar/theme";
@import "~vue-material/dist/components/MdCard/theme";
@import "~vue-material/dist/components/MdButton/theme";
@import "~vue-material/dist/components/MdField/theme";
@import "~vue-material/dist/components/MdProgress/theme";

.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-title {
  text-align: center;
}
.md-button {
  font-weight: bold;
}

</style>
<style>
.md-checkbox {
  width: auto;
  margin: 16px 16px 16px 0;
  display: inline-flex;
  position: relative;
}
.md-checkbox:not(.md-disabled),
.md-checkbox:not(.md-disabled) .md-checkbox-label {
  cursor: pointer;
}
.md-checkbox .md-checkbox-container {
  width: 20px;
  min-width: 20px;
  height: 20px;
  position: relative;
  border-radius: 2px;
  border: 2px solid transparent;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.md-checkbox .md-checkbox-container:focus {
  outline: none;
}
.md-checkbox .md-checkbox-container:after,
.md-checkbox .md-checkbox-container:before {
  position: absolute;
  transition: 0.4s cubic-bezier(0.55, 0, 0.55, 0.2);
  content: " ";
}
.md-checkbox .md-checkbox-container:before {
  width: 48px;
  height: 48px;
  top: 50%;
  left: 50%;
  z-index: 6;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.md-checkbox .md-checkbox-container:after {
  width: 6px;
  height: 13px;
  top: 0;
  left: 5px;
  z-index: 7;
  border: 2px solid transparent;
  border-top: 0;
  border-left: 0;
  opacity: 0;
  transform: rotate(45deg) scale3D(0.15, 0.15, 1);
}
.md-checkbox .md-checkbox-container .md-ripple {
  width: 48px !important;
  height: 48px !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.md-checkbox .md-checkbox-container input {
  position: absolute;
  left: -999em;
}
.md-checkbox .md-checkbox-label {
  height: 20px;
  padding-left: 16px;
  position: relative;
  line-height: 20px;
}
.md-checkbox.md-indeterminate .md-checkbox-container:after {
  width: 12px;
  height: 2px;
  top: 50%;
  left: 50%;
  z-index: 4;
  border-style: solid;
  border-width: 0 0 2px;
  opacity: 0;
  transform: translate(-50%, -50%) !important;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  opacity: 1;
  transform: rotate(45deg) scaleX(1);
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.md-checkbox.md-disabled.md-checked .md-checkbox-container {
  border-color: transparent !important;
}
.md-checkbox.md-required label:after {
  position: absolute;
  top: 2px;
  right: 0;
  transform: translateX(calc(100% + 2px));
  content: "*";
  line-height: 1em;
  vertical-align: top;
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background-color: #f2ce9b;
  background-color: var(--md-theme-default-accent, #f2ce9b);
  border-color: #f2ce9b;
  border-color: var(--md-theme-default-accent, #f2ce9b);
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: #fff;
  border-color: var(--md-theme-default-background, #fff);
}
.md-checkbox.md-theme-default.md-checked .md-ripple {
  color: #f2ce9b;
  color: var(--md-theme-default-accent, #f2ce9b);
}
.md-checkbox.md-theme-default.md-indeterminate .md-checkbox-container {
  background-color: hsla(0, 0%, 100%, 0.3);
}
.md-checkbox.md-theme-default.md-checked.md-primary .md-checkbox-container {
  background-color: #f2ce9b;
  background-color: var(--md-theme-default-primary, #f2ce9b);
  border-color: #f2ce9b;
  border-color: var(--md-theme-default-primary, #f2ce9b);
}
.md-checkbox.md-theme-default.md-checked.md-primary .md-ripple {
  color: #f2ce9b;
  color: var(--md-theme-default-primary, #f2ce9b);
}
.md-checkbox.md-theme-default.md-indeterminate .md-checkbox-container {
  border-color: rgba(0, 0, 0, 0.54);
  background-color: transparent;
}
.md-checkbox.md-theme-default.md-indeterminate .md-checkbox-container:after {
  border-color: rgba(0, 0, 0, 0.54);
}
.md-checkbox.md-theme-default.md-indeterminate .md-ripple {
  color: rgba(0, 0, 0, 0.54);
}
.md-checkbox.md-theme-default .md-checkbox-container {
  border-color: rgba(0, 0, 0, 0.54);
}
.md-checkbox.md-theme-default.md-disabled .md-checkbox-container {
  border-color: rgba(0, 0, 0, 0.26);
}
.md-checkbox.md-theme-default.md-disabled.md-checked .md-checkbox-container {
  border-color: rgba(0, 0, 0, 0.26);
  background-color: rgba(0, 0, 0, 0.26);
}
</style>